import DEMO_ACCOUNT_DATASET, { DEMO_DOMAINS, DEMO_FIRSTNAMES, DEMO_LASTNAMES } from "../types/consts/dataset/demo-account";

import { getRandomElement } from "./utils";

export const getDemoAccountDataset = (): typeof DEMO_ACCOUNT_DATASET => {
    const firstname = getRandomElement(DEMO_FIRSTNAMES);
    const lastname = getRandomElement(DEMO_LASTNAMES);
    return {
        ...DEMO_ACCOUNT_DATASET,
        demo_account: {
            ...DEMO_ACCOUNT_DATASET.demo_account,
            user: {
                ...DEMO_ACCOUNT_DATASET.demo_account.user,
                firstname: firstname,
                lastname: lastname,
                email_domain: getRandomElement(DEMO_DOMAINS),
            },
            subscription: {
                ...DEMO_ACCOUNT_DATASET.demo_account.subscription,
                name: `${DEMO_ACCOUNT_DATASET.demo_account.subscription.sender[0]} - Leed Group (DEMO) - ${firstname} ${lastname}`,
            },
        }
    }
}